<template>
  <p :title="title" :style="styleObj">
    <span class="circle">&#9679;</span>
    <strong
      v-if="bold && italic"
      @click="applySubStyle"
      @mousedown.prevent.stop="onMouseDown"
    >
      <em>
        <span
          class="wt-substyle-caption"
          :class="[fontName, { bright: isBrightColor }]"
          v-text="applyStyleText"
        ></span>
      </em>
    </strong>
    <strong
      v-if="bold && !italic"
      @click="applySubStyle"
      @mousedown.prevent.stop="onMouseDown"
    >
      <span
        class="wt-substyle-caption"
        :class="[fontName, { bright: isBrightColor }]"
        v-text="applyStyleText"
      ></span>
    </strong>
    <em
      v-if="italic && !bold"
      @click="applySubStyle"
      @mousedown.prevent.stop="onMouseDown"
    >
      <span
        class="wt-substyle-caption"
        :class="[fontName, { bright: isBrightColor }]"
        v-text="applyStyleText"
      ></span>
    </em>
    <span
      v-if="!italic && !bold"
      @click="applySubStyle"
      @mousedown.prevent.stop="onMouseDown"
    >
      <span
        class="wt-substyle-caption"
        :class="[fontName, { bright: isBrightColor }]"
        v-text="applyStyleText"
      ></span>
    </span>
  </p>
</template>

<script>
/** (GW)
 * Asset Editor's text overlay stage Vue (stage bar)
 */

import app from 'app';
import Analytics from 'c/WtAnalytics';

const track = _.debounce(function (e, obj) {
  Analytics.trigger('analytics:textOverlay:' + e, obj);
}, 500);

export default {
  props: [
    'color',
    'italic',
    'bold',
    'font-name',
    'is-default',
    'is-active',
    'index',
    'bg-color',
    'isGradient',
  ],
  data: function () {
    return {
      applyStyleText:
        app.fontController.getApplyText(this.fontName) || 'Use this format',
    };
  },
  methods: {
    applySubStyle: function () {
      const props = {
        color: this.color,
        italic: this.italic,
        bold: this.bold,
        fontName: this.fontName,
      };
      track('applySubStyle', props);
      this.$emit('apply-sub-style', props, this.index);
    },
    onMouseDown: function () {},
  },
  computed: {
    title: function () {
      const res = [this.fontName, this.color];
      if (this.bold) {
        res.push('bold');
      }
      if (this.italic) {
        res.push('italic');
      }
      return res.join('; ');
    },
    isBrightColor: function () {
      const bg = tinycolor(this.bgColor);
      const fg = tinycolor(this.color);
      return (
        !this.isGradient &&
        (bg.getBrightness() > 230 || bg.getAlpha() === 0) &&
        fg.getBrightness() > 230
      );
    },
    styleObj: function () {
      return _.extend(
        {},
        { color: this.color, flex: 1, background: this.bgColor }
      );
    },
  },
};
</script>
